
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';
import { SubRoom } from '@/utils/models';
import { uploadFile } from '@/utils/functions';
import { DataService } from '@/service/DataService';
import ConfirmCancellationPopup from '@/components/popup/common/ConfirmCancellationPopup.vue';

@Component({ components: { Popup, ConfirmCancellationPopup } })
export default class EditSubRoomPropsPopup extends Vue {
  @Prop() subRoom!: SubRoom;
  @Emit()
  close() {}
  @Emit()
  apply(subroom: SubRoom | null) {}
  target: SubRoom = {} as any;
  original: SubRoom = {} as any;
  showConfirmCancellation = false;

  get subroomName(): string {
    return this.subRoom.name ?? '';
  }

  get canApply(): boolean {
    return (
      this.target.name !== this.original.name ||
      this.target.showName !== this.original.showName ||
      this.target.nameStyle !== this.original.nameStyle ||
      this.target.areaStyle !== this.original.areaStyle ||
      this.target.volume !== this.original.volume ||
      this.target.bgmUrl !== this.original.bgmUrl ||
      this.target.bgmAudioVolume !== this.original.bgmAudioVolume
    );
  }
  mounted() {
    const { subid, name, showName, nameStyle, areaStyle, topLeft, bottomRight, volume, bgmUrl, bgmAudioVolume } =
      this.subRoom;
    this.target = {
      subid,
      name,
      showName,
      nameStyle: nameStyle ?? '',
      areaStyle: areaStyle ?? '',
      topLeft,
      bottomRight,
      volume: volume ?? -1,
      bgmAudioVolume: bgmAudioVolume ?? 0.1,
      bgmUrl: bgmUrl ?? '',
      userStates: [],
    };
    this.original = {
      subid,
      name,
      showName,
      nameStyle: nameStyle ?? '',
      areaStyle: areaStyle ?? '',
      topLeft,
      bottomRight,
      volume: volume ?? -1,
      bgmAudioVolume: bgmAudioVolume ?? 0.1,
      bgmUrl: bgmUrl ?? '',
      userStates: [],
    };
  }
  openFileSelector() {
    let el = this.$refs.fileSelecter as HTMLInputElement;
    if (!el) {
      return;
    }
    el.value = '';
    el.click();
  }
  async onFileChanged(ev: Event) {
    let el = ev.target as HTMLInputElement;
    if (!el || !el.files?.length) {
      return;
    }
    const url = await uploadFile(this.$store.state.dataService as DataService, 'audio', el.files[0]);
    if (this.target) {
      this.target.bgmUrl = url;
    }
  }
  hidePopup(): void {
    this.close();
  }
  closeOrShowConfirmCancellation(): void {
    if (this.canApply) {
      this.showConfirmCancellation = true;
    } else {
      this.close();
    }
  }
  closeConfirmCancellation(): void {
    this.showConfirmCancellation = false;
  }
}
